import DocUpload from "./DocUpload";
import ExpenseClaim from "./ExpenseClaim";
import ExpenseClaimAdd from "./ExpenseClaimAdd";
import ExpenseClaimSettings from "./ExpenseClaimSettings";

const ExpenseClaimConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: "/expense-claim",
      element: <ExpenseClaim />,
    },
    {
      path: "/expense-claim/add",
      element: <ExpenseClaimAdd />,
    },
    {
      path: "/expense-claim/docUpload",
      element: <DocUpload />,
    },
    {
      path: "/expense-claim/config",
      element: <ExpenseClaimSettings />,
    },
  ],
};

export default ExpenseClaimConfig;
